import { useState, useEffect, useRef } from 'react';
import { useTranslations } from 'next-intl';
import { useUnsettledStatusCountInfo } from '@/hooks/query';

interface TipProps {
	className?: string;
	auto: boolean;
}

export const Tip = ({ className, auto }: TipProps) => {
	const t = useTranslations('General');
	const [isOpen, setIsOpen] = useState(false);
	const waitingCountRef = useRef<ReturnType<typeof setInterval>>();
	const [waitingCount, setWaitingCount] = useState(0);
	const isFirstRender = useRef(true);
	const { statusCount, refetchUnsettledStatusCount } = useUnsettledStatusCountInfo(auto ? 1 : 0);

	const clearTipTimeout = () => {
		setIsOpen(false);
	}

	useEffect(() => {
		clearInterval(waitingCountRef.current);
		if (statusCount) {
			setWaitingCount(statusCount?.WC);
			if (statusCount?.WC > 0) {
				waitingCountRef.current = setInterval(() => {
					refetchUnsettledStatusCount();
				}, 6000);
			}
		}
		return () => {
			clearInterval(waitingCountRef.current);
		}
	}, [statusCount, refetchUnsettledStatusCount]);

	useEffect(() => {
		// 检查是否不是第一次渲染
		if (!isFirstRender.current) {
			setIsOpen(true);

			setTimeout(() => {
				clearTipTimeout();
			}, 2000);
		} else {
			// 更新 ref 的值以指示不再是第一次渲染
			isFirstRender.current = false;
		}
		
	}, [waitingCount]);

	return (
		<div className={className} data-open={isOpen}>
			<div className="scrollbar scrollbar--tip">
				<div className="tip__content">{t('lbl_TicketStatusAlert')}</div>
			</div>
		</div>
	);
}